import React from "react";

const MFvsPersonsTab = () => {
  return (
    <div className="card">
      <div className="card-body">
        <h4>MF vs Persons Content</h4>
        {/* MF vs Persons content goes here */}
        <p>This is the MF vs Persons tab content.</p>
      </div>
    </div>
  );
};

export default MFvsPersonsTab;
